/* unplugin-vue-components disabled */import script from "./microsite-quotes.vue?vue&type=script&lang=js"
export * from "./microsite-quotes.vue?vue&type=script&lang=js"

import "./microsite-quotes.vue?vue&type=style&index=0&id=8f67f3c0&lang=scss"

const __exports__ = script;

export default __exports__